module.exports = __webpack_public_path__ + "media/77_Long.2ec6fa59.mp3";